<app-selo *ngFor="let selo of selos" [selo]="selo"    class="alinhados" >
</app-selo>

